import Caption from "@components/controls/Caption";
import type { Editor } from "@tiptap/core";
import type { Attrs } from "@tiptap/pm/model";
import { type RefObject, useEffect } from "react";

interface BlockCaptionProps {
	editor: Editor;
	getPos: () => number;
	signatureRef: RefObject<HTMLInputElement>;
	text: string;
	visible: boolean;
	setVisible: (visible: boolean) => void;
	updateAttributes: (attrs: Attrs) => void;
}

export const BlockCaption = ({
	editor,
	getPos,
	signatureRef,
	text,
	visible,
	setVisible,
	updateAttributes,
}: BlockCaptionProps) => {
	useEffect(() => {
		if (text?.length) setVisible(true);
	}, [text, setVisible]);
	return (
		<Caption
			editor={editor}
			getPos={getPos}
			onLoseFocus={(event) => {
				if (visible || (event.target as HTMLInputElement).value.length) return;
				updateAttributes({ title: "" });
				setVisible(false);
			}}
			onUpdate={(title) => updateAttributes({ title })}
			ref={signatureRef}
			text={text}
			visible={visible}
		/>
	);
};
